import Vue from 'vue'
let div;

let directives = {
  active: {
    inserted(el){
      let removeClassName = (item) => {
          let className = item.className.split(/\s+/g);
          className = className.filter(item => item !== 'active');
          item.className = className.join(' ');
        },
        setClassName = (item, klass) => {
          let className = item.className.split(/\s+/g);
          className.push(klass);
          item.className = className.join(' ');
        };
        div = el.parentNode.getElementsByTagName('div');
        div = [].slice.call(div);

      el.onclick = () => {
        div.forEach(item => {
          removeClassName(item)
        });
        setClassName(el, 'active');
      };
    },
    update(el){
        div = el.parentNode.getElementsByTagName('div');
        div = [].slice.call(div);
    }
  },
  
};
export default directives